import React, {Component} from 'react';

export default class NotFound extends Component {
    render() {
        return (
            <div className="container">
                <h2>404 - Not Found</h2>
                <p>Whoops! This page does not exist</p>
            </div>
        );
    }
}
